"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _WithTheme = _interopRequireDefault(require("../WithTheme"));

var _theme = require("./theme");

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function UTTextArea(_ref) {
  var onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      value = _ref.value,
      classes = _ref.classes,
      className = _ref.className,
      disabled = _ref.disabled,
      placeholder = _ref.placeholder;
  return _react["default"].createElement("textarea", {
    className: "".concat(_stylesModule["default"].textarea, " ").concat(className, " ").concat(classes.textarea),
    onChange: onChange,
    onBlur: onBlur,
    onFocus: onFocus,
    value: value,
    disabled: disabled,
    placeholder: placeholder
  });
}

UTTextArea.propTypes = {
  onChange: _propTypes.func.isRequired,
  onBlur: _propTypes.func.isRequired,
  onFocus: _propTypes.func.isRequired,
  value: _propTypes.string.isRequired,
  disabled: _propTypes.bool,
  placeholder: _propTypes.string,
  className: _propTypes.string,
  classes: (0, _propTypes.shape)(_propTypes.any)
};

var _default = (0, _WithTheme["default"])(_theme.retrieveStyle)(UTTextArea);

exports["default"] = _default;